// extracted by mini-css-extract-plugin
export default {"Admin":"Admin_Admin__Bz5S3","Outlet":"Admin_Outlet__l-BaA"};